import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const getDeviceId = () => {
  let id = localStorage.getItem("bizkids_device_id");
  if (!id) {
    id = `dev_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem("bizkids_device_id", id);
  }
  return id;
};

export const startCheckout = async () => {
  const { data } = await axios.post(`${API}/api/payments/checkout`, {
    origin_url: window.location.origin,
    device_id: getDeviceId(),
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/api/payments/status/${sessionId}`);
  return data;
};

export const restorePurchase = async (email) => {
  const { data } = await axios.post(`${API}/api/payments/restore`, { email });
  return data;
};

export const adminUnlock = async (code) => {
  const { data } = await axios.post(`${API}/api/admin/unlock`, { code });
  return data;
};

export const redeemPromo = async (code) => {
  const { data } = await axios.post(`${API}/api/promo/redeem`, { code });
  return data;
};

export const adminPromos = {
  list: async (code) => (await axios.post(`${API}/api/admin/promos/list`, { code })).data.promos,
  add: async (code, promo) => (await axios.post(`${API}/api/admin/promos/add`, { code, promo })).data,
  toggle: async (code, promo, active) => (await axios.post(`${API}/api/admin/promos/toggle`, { code, promo, active })).data,
  remove: async (code, promo) => (await axios.post(`${API}/api/admin/promos/delete`, { code, promo })).data,
};

export const verifyUnlock = async (ref, token) => {
  const { data } = await axios.post(`${API}/api/entitlement/verify`, { ref, token });
  return data.unlocked;
};

export const registerLeaderboardPlayer = async () => {
  const { data } = await axios.post(`${API}/api/leaderboard/register`);
  return data;
};

export const saveGame = async (state, code) => {
  const { data } = await axios.post(`${API}/api/saves`, { state, code: code || null });
  return data;
};

export const loadGame = async (code) => {
  const { data } = await axios.get(`${API}/api/saves/${encodeURIComponent(code.trim())}`);
  return data;
};

export const fetchLeaderboard = async (playerId, boardType = "all") => {
  const { data } = await axios.get(`${API}/api/leaderboard`, { params: { player_id: playerId, board_type: boardType } });
  return data;
};

export const postScore = async (payload) => {
  const { data } = await axios.post(`${API}/api/leaderboard`, payload);
  return data;
};
